import { render, staticRenderFns } from "./BomDetailsSelector.vue?vue&type=template&id=74b31a7d&scoped=true"
import script from "./BomDetailsSelector.vue?vue&type=script&lang=js"
export * from "./BomDetailsSelector.vue?vue&type=script&lang=js"
import style0 from "./BomDetailsSelector.vue?vue&type=style&index=0&id=74b31a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b31a7d",
  null
  
)

export default component.exports